import styled from "styled-components";

export const FormInner = styled.form``;
